import { Provider } from "react-redux";
// import BlogData from "../../data/tfm/terraform-modules.json";
import PageHead from "../Head";
import Store from "@/redux/store";
import Context from "@/context/Context";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
// import Cart from "@/components/Header/Offcanvas/Cart";
import BlogList from "@/components/Blogs/BlogList";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import Banner from "@/components/Common/Banner";
import BackToTop from "../backToTop";
import React, { useState, useEffect } from "react"
import CPStaticContent from '../../models/CPStaticContent.js'
import Instagram from "@/components/Instagram/Instagram";

const BlogListLayout = (post) => {

  const tfModules = {}
  tfModules['blogList'] = post.list
  // console.log(tfModules)

  return (
    <>
      <PageHead title="Terraform Modules developed by CloudPedia" description="Collection of Terraform Modules developed by CloudPedia" />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          {/* <Cart /> */}

          <Banner
            col="col-lg-10 offset-lg-1"
            text="Terraform Modules"
            description={"Official documentation for Terraform Modules developed by CloudPedia"}
            getBlog={tfModules.blogList}
            listType="Modules"
          />

          <div className="rbt-blog-area rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="container">
              <BlogList
                isPagination={true}
                blogData={tfModules}
                blogType={"terraform-module"} />
            </div>
          </div>

          <Instagram />
          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default BlogListLayout;

export async function getStaticProps(context) {
  const stContent = new CPStaticContent("tfmdocs")
  await stContent.fetchContent()
  return await stContent.getListProps()
} 